<template>
    <div class='product'>
        <div class='productContainer'>
            <myPictures style='width:90%;'></myPictures>
            <div class='tab'>
                <div class='tablinks' @click="open($event, 'personal')" id='defaultOpen' ref="personal">
                    <div id='img0'></div>
                    <span>个人字幕服务</span>
                </div>
                <div class='tablinks' @click="open($event, 'institution')" ref='institution'>
                    <div id='img1'></div>
                    <span>机构字幕服务</span>
                </div>
                <div class='tablinks' @click="open($event, 'speech')" ref='speech'>
                    <div id='img2'></div>
                    <span>言语康复服务</span>
                </div>
                <div class='tablinks' @click="open($event, 'service')" ref='service'>
                    <div id='img3'></div>
                    <span>手语服务</span>
                </div>
            </div>
            <div id='personal' class='tabcontent'>
                <personalSS></personalSS>
            </div>
            <div id='institution' class='tabcontent'>
                <institutionSS></institutionSS>
            </div>
            <div id='speech' class='tabcontent'>
                <speechRS></speechRS>
            </div>
            <div id='service' class='tabcontent'>
                <signLS></signLS>
            </div>
        </div>
        <myFooter></myFooter>
        <customer-service />
    </div>
</template>

<script>
import personalSubtitleService from '../components/personalSubTitleService'
import institutionSubtitleService from '../components/institutionSubtitleService'
import speechRehabitationService from '../components/speechRehabitationService'
import signLanguageService from '../components/signLanguageService'
import bus from '@/lib/bus.js'
import CustomerService from '@/components/CustomerService.vue'

export default {
    name: 'productPage',
    components: {
        'personalSS': personalSubtitleService,
        'institutionSS': institutionSubtitleService,
        'speechRS': speechRehabitationService,
        'signLS': signLanguageService,
        CustomerService
    },
    mounted () {
        bus.$emit('changeSelectedIndex', 1)
        if (this.$route.params.key) {
            console.log(this.$route.params.key, this.$route.params.anchor, this.$route.name)
            this.$refs[this.$route.params.key].click()
            if (this.$route.params.anchor !== 'none') location.href = '#' + this.$route.params.anchor
        }
    },
    methods: {
        open: function (evt, tabName) {
            var i, tabcontent, tablinks
            tabcontent = document.getElementsByClassName('tabcontent')
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = 'none'
            }
            tablinks = document.getElementsByClassName('tablinks')
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(' active', '')
            }
            document.getElementById(tabName).style.display = 'block'
            evt.currentTarget.className += ' active'
        }
    }
}
</script>

<style scoped>
@import './product.css'
</style>



// WEBPACK FOOTER //
// src/pages/Product.vue